import { useQuery } from "react-query";
import { fetchPatientNotes } from "@/services/patient-content";
var DEFAULT_PAGE_SIZE = 10;

/** Query hook for the patient's recent notes, enabled on demand. */
export function usePatientNotes(patientId, enabled) {
  var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_PAGE_SIZE;
  return useQuery(["patient-notes", patientId, pageSize], function () {
    return fetchPatientNotes(patientId, pageSize);
  }, {
    enabled: enabled && Boolean(patientId)
  });
}